module.exports = __webpack_public_path__ + "img/list2.1457d805.png";